import { wrapperClassName } from "../../../constants";
import { joinClassName } from "../../../utils/cssUtils";
import { makeContentLayout } from "../utils/contentLayoutUtil";

export const oneCol = makeContentLayout({
    wrapperClasses: "",
    contentClasses: "",
});

export const fullWidth = oneCol.with({
    wrapperClasses: joinClassName(wrapperClassName, "fullWidth"),
    contentClasses: joinClassName(wrapperClassName, "fullWidth", "content"),
});

export const verticalCol = makeContentLayout({
    wrapperClasses: joinClassName(wrapperClassName, "verticalCol"),
    contentClasses: joinClassName(wrapperClassName, "verticalCol", "content"),
});
